module.exports = __webpack_public_path__ + "static/media/cloud-upload.1c324989.svg";